import { UserGeneratedHtml } from '@atlassian/mpac-ui';
import React, { useCallback, useState } from 'react';
import { TEST_ID } from "../../../../../constants";
import Image from "../../../../Image";
import MediaViewer from "../../../../MediaViewer";
import FallbackInstallationDocumentation from "../FallbackInstallationDocumentation";
import { InstallationStepItem as Item, InstallationStepsList as List } from "../styles";
import { InstallationScreenshotContainer } from "./styles";
export const getInstructionMediaItem = instruction => ({
  dataURI: instruction.screenshot.url,
  name: instruction.instruction
});
const getMediaItems = instructions => {
  return instructions.filter(instruction => Boolean(instruction.screenshot)).map(instruction => getInstructionMediaItem(instruction));
};
const InstructionalAppInstallationSteps = props => {
  const {
    instructions,
    appName,
    documentationUrl
  } = props;
  const [activeMedia, setActiveMedia] = useState(null);
  const handleMediaViewerClose = useCallback(() => setActiveMedia(null), []);
  const handleMediaItemSelect = useCallback(instruction => {
    setActiveMedia({
      dataURI: instruction.screenshot,
      name: instruction.instruction
    });
  }, []);
  if (!instructions.length) {
    return /*#__PURE__*/React.createElement(FallbackInstallationDocumentation, {
      appName: appName,
      documentationUrl: documentationUrl
    });
  }
  return /*#__PURE__*/React.createElement(List, null, activeMedia && /*#__PURE__*/React.createElement(MediaViewer, {
    mediaItems: getMediaItems(instructions),
    selectedMediaItem: activeMedia,
    onClose: handleMediaViewerClose
  }), instructions.map((instruction, index) => {
    const {
      instruction: content,
      screenshot
    } = instruction;
    return /*#__PURE__*/React.createElement(Item, {
      key: "".concat(content, "-").concat(index)
    }, /*#__PURE__*/React.createElement(UserGeneratedHtml, {
      dangerousHtml: content
    }), screenshot && /*#__PURE__*/React.createElement(InstallationScreenshotContainer, null, /*#__PURE__*/React.createElement(Image, {
      image: screenshot,
      "data-testid": TEST_ID.INSTALLATION_TAB_STEP_SCREENSHOT,
      onClick: () => handleMediaItemSelect({
        instruction: content,
        screenshot: screenshot.url
      })
    })));
  }));
};
export default InstructionalAppInstallationSteps;